require('./style.scss')
class ResourceSelectorDirective
  @$inject: []
  constructor: ()->              
    class ResourceSelector      
      restrict: "C"
      require: ["selector"]
      scope: true
      template: require('./index.pug')
      link: (scope, element, attrs, controllers)->
        selector = controllers[0]
        scope.$watch attrs.filter, (val)->
          if val
            {type} = val
            if type? and type.length is 1 and type[0] is "FOLDER"
              scope.mode = "FOLDER"
              
    return new ResourceSelector()

  
module.exports = ResourceSelectorDirective


// WEBPACK FOOTER //
// ./src/component/resource/selector/index.coffee